import type { Category, Post } from '@/payload-types'

import {
  getCategoryBadgeColor,
  getCategoryColorFromCategories,
} from './categoryColor'
import { getPostReadTimeLabel } from './readTime'

export const DEFAULT_POST_HERO_IMAGE = '/media/posts/image%207.webp'

export type BlogPostData = Pick<
  Post,
  | 'id'
  | 'title'
  | 'slug'
  | 'categories'
  | 'heroImage'
  | 'meta'
  | 'shortDescription'
  | 'content'
>

export function getPostCardReadTime(
  post: Pick<BlogPostData, 'content'>,
  template: string,
): string {
  return getPostReadTimeLabel(post.content, template)
}

export function getPostCardDescription(
  post: Pick<BlogPostData, 'meta' | 'shortDescription'>,
): string | undefined {
  if (post.shortDescription?.trim()) {
    return post.shortDescription.trim()
  }

  return post.meta?.description?.trim() || undefined
}

export function getPostCardImage(post: Pick<BlogPostData, 'heroImage'>) {
  const heroImage = post.heroImage
  if (heroImage && typeof heroImage === 'object') return heroImage

  return null
}

export function getCategoryTitle(
  categories: BlogPostData['categories'],
): string | undefined {
  if (!categories || !Array.isArray(categories) || categories.length === 0) {
    return undefined
  }

  const first = categories[0]

  if (typeof first === 'object' && first !== null) {
    return (first as Category).title ?? undefined
  }

  return undefined
}

export function getPostCardCategoryColor(
  post: Pick<BlogPostData, 'categories'>,
  options: {
    colorByTitle?: Record<string, string>
    index?: number
  } = {},
): string {
  const { colorByTitle = {}, index = 0 } = options
  const categoryTitle = getCategoryTitle(post.categories)

  return (
    getCategoryColorFromCategories(post.categories, colorByTitle) ??
    getCategoryBadgeColor(categoryTitle, index, colorByTitle)
  )
}
